import { combineReducers } from 'redux';
import { snackbarReducers } from './snackbar';
import { userReducers } from './user';
import { contactsReducers } from './contacts';
import { templateReducer } from './templateBuilder';
import { ordersReducers } from './orders';
import { productReducers } from './product';
import { apiKeysReducers } from './apiKeys';
import { stripeReducers } from './stripe';
import { customFieldsReducers } from './customFields';
import { tagsReducers } from './tags';
import { dashboardReducers } from './dashboard';
import { webhooksReducers } from './webhooks';
import { sourcesReducers } from './sources';
import { generalSettingsReducers } from './generalSetting';
import { brandingAssetsReducers } from './brandingAssets';
import { campaignsReducers } from './campaigns';

// Admin Reducers
import { adminUsersReducers } from './adminUsers';
import { adminBatchesReducers } from './adminBatches';
import { adminOrdersReducers } from './adminOrders';
import { adminDashboardReducers } from './adminDashboard';
import { adminTemplatesReducers } from './adminTemplates';
import { adminLookupsReducers } from './adminLookups';
import { adminQueriesReducers } from './adminQueries';
import { adminPricingReducers } from './adminPricing';
import { contactImportsReducers } from './contactImports';
import { exportLogsReducers } from './exportLogs';
import { phoneTrackingReducers } from './phoneTracking';
import { senderProfilesReducers } from './senderProfiles';
import { qrCodesReducers } from './qrCodes';
import { designerQueriesReducers } from './designerQueries';
import { paymentFailureReducer } from './paymentFailure';
import { twoFactorReducer } from './twoFactor';

const reducer = combineReducers({
  snackbarReducers,
  userReducers,
  contactsReducers,
  templateReducer,
  ordersReducers,
  productReducers,
  apiKeysReducers,
  stripeReducers,
  customFieldsReducers,
  tagsReducers,
  dashboardReducers,
  webhooksReducers,
  generalSettingsReducers,
  brandingAssetsReducers,
  adminUsersReducers,
  adminBatchesReducers,
  adminOrdersReducers,
  adminDashboardReducers,
  adminTemplatesReducers,
  adminLookupsReducers,
  sourcesReducers,
  adminQueriesReducers,
  adminPricingReducers,
  contactImportsReducers,
  campaignsReducers,
  exportLogsReducers,
  phoneTrackingReducers,
  senderProfilesReducers,
  qrCodesReducers,
  designerQueriesReducers,
  paymentFailureReducer,
  twoFactorReducer,
});

export default reducer;
